import * as React from "react"
import { Checkbox } from "@tenforce/toolbox-selector-react"
import { Cell, RowContent } from "@tenforce/toolbox-table-react"
import { FieldItems, ReadOnly } from "@tenforce/toolbox-field-react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import bem from "../../../bem"
import { Symbols } from "@tenforce/toolbox-fontmap"

import "./Contract.scss"
import { Labels } from "../../../util/Translations"

const b = bem.with("NewUI__contract")

interface Props {
    contract: Contracts.Contract
    validating?: boolean
    setEnabled: (id: string, enabled: boolean) => void
    show: (id: string) => void
    validate: (id: string) => void
}

const enum ValidationStatus {
    Unknown = "unknown",
    Compliant = "compliant",
    Violated = "violated",
}

export default class Contract extends React.PureComponent<Props> {
    render(): JSX.Element {
        const { contract, validating } = this.props
        const validationClass = b("status__" + this.getValidationStatus())
        const { Details, Validate } = Labels
        return (
            <RowContent
                extraClasses="has-hidden-actions"
                data-ft-contract={"contract-" + contract.id}
            >
                <Cell size="0" extraClasses={b("status")}>
                    <span
                        className={`tw-pl-3 ${validationClass} ${
                            validating && "is-loading"
                        }`}
                    >
                        {Symbols.Bullet}
                    </span>
                </Cell>
                <Cell size="1">
                    <FieldItems>
                        <ReadOnly value={contract.name} />
                    </FieldItems>
                </Cell>
                <Cell size="0.5">
                    <FieldItems>
                        <Checkbox
                            isChecked={contract.enabled}
                            isRequired={true}
                            onChecked={(): void => this.setEnabled(true)}
                            onUnchecked={(): void => this.setEnabled(false)}
                        />
                    </FieldItems>
                </Cell>
                <Cell size="2">
                    <Action
                        actionType={ActionType.icon}
                        onClick={this.show}
                        extraClasses="is-hidden-action"
                    >
                        {Symbols.Script}&nbsp;{Details}
                    </Action>
                    <Action
                        actionType={ActionType.icon}
                        onClick={this.validate}
                        extraClasses="is-hidden-action"
                    >
                        {Symbols.ArrowCheck}&nbsp;{Validate}
                    </Action>
                </Cell>
            </RowContent>
        )
    }

    setEnabled = (enabled: boolean): void => {
        const { contract, setEnabled } = this.props
        setEnabled(contract.id, enabled)
    }

    show = (): void => {
        const { contract, show } = this.props
        show(contract.id)
    }

    validate = (): void => {
        const { contract, validate } = this.props
        validate(contract.id)
    }

    getValidationStatus = (): ValidationStatus => {
        const { contract, validating } = this.props
        if (validating || !contract.status) {
            return ValidationStatus.Unknown
        }
        return contract.status.compliant
            ? ValidationStatus.Compliant
            : ValidationStatus.Violated
    }
}
